import React, { useState, useEffect } from "react";
import axios from "axios";
import Header from "../../components/header";
import Sidebar from "../../components/sidebar";

const MasterLedgerReport = () => {
  // const today = new Date().toISOString().split('T')[0];
  const today = new Date();
  const [endDate, setEndDate] = useState(today.toISOString().split('T')[0]);
  const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 2).toISOString().split('T')[0];
  const [startDate, setStartDate] = useState(firstDayOfMonth);
  const [ledgers, setLedgers] = useState([]);
  const [invoices, setInvoices] = useState([]);
  const [reciepts, setReciepts] = useState([]);
  const [cdNote, setCdNote] = useState([]);
  const [bankCollection, setBankCollection] = useState([]);
  const [selLedg, setSelLedg] = useState('');
  const [expandedDate, setExpandedDate] = useState(null);


  const toggleDate = (date) => {
    setExpandedDate(prev => (prev === date ? null : date));
  };


  // console.log("Start Date:", startDate);
  // console.log("End Date:", endDate);
  // console.log("Ledgers Data:", ledgers);
  // console.log(invoices);

  const handleFetchData = async () => {
    try {
      const response = await axios.post("https://api.trucoo.in/ledger/master-ledger/", {
        start: startDate,
        end: endDate
      }, {
        headers: {
          "Content-Type": "application/json",
          "X-API-KEY": "erpTrucoo"
        }
      });

      // console.log("Ledger Summary Response:", response.data);

      if (response.data.status === 'success') {
        setLedgers(response.data.ledger);
        setInvoices(response.data.invoices);
        setReciepts(response.data.reciepts);
        setCdNote(response.data.cdNote);
        setBankCollection(response.data.bankCollection);
      }
    } catch (err) {
      console.error("Error fetching ledger summary:", err.message);
    }
  };

  useEffect(()=>{
    handleFetchData();
  },[startDate, endDate]);

  function getFiscalYearLabel(date = new Date()) {
    const year = date.getFullYear();
    const month = date.getMonth(); 
    if (month < 3) {
        return `${(year-1).toString().slice(-2)}-${year.toString().slice(-2)}`;
    } else {
        return `${year.toString().slice(-2)}-${(year + 1).toString().slice(-2)}`;
    }
  };
  

  const getLedgerTotal = (ledgerId, data) => {

    let total = 0;

    data?.forEach((items) => {
      if(items?.master === ledgerId){
        total += Number(items?.amount || 0);
      }
    });

    return total;

  };

  const invoiceTotal = invoices?.reduce((sum, invoice) => sum + Number(invoice?.amount), 0);

  const groupedInvoices = invoices.reduce((acc, inv) => {
    const { date, amount, orderData = [] } = inv;
    const numericAmount = Number(amount) || 0;

    if (!acc[date]) {
      acc[date] = {
        date,
        totalAmount: 0,
        count: 0,
        milkSales: 0,
        curdSales: 0,
        otherSales: 0,
        invoices: []
      };
    }

    // invoice-level totals
    acc[date].totalAmount += numericAmount;
    acc[date].count += 1;

    // item-level totals
    orderData.forEach(item => {
      const itemTotal =
        Number(item?.itemPrice || 0) *
        Number(item?.itemGrade || 0) *
        Number(item?.qty || 0);

      if (item?.itemType === 'milk') {
        acc[date].milkSales += itemTotal;
      } else if (item?.itemType === 'curd') {
        acc[date].curdSales += itemTotal;
      } else {
        acc[date].otherSales += itemTotal;
      }
    });

    acc[date].invoices.push(inv);

    return acc;
  }, {});


  const getSalesValue = (type, data) => {
    let sales = 0;
    data?.forEach(items => {
      if(items?.itemType === type){
        const itemTotal = parseFloat(items?.itemPrice) * ( parseFloat(items?.itemGrade) * parseFloat(items?.qty));
        sales += itemTotal;
      }
    });

    return sales;
  };

  const getSalesValueOthers = (data) => {
    let sales = 0;
    data?.forEach(items => {
      if (items?.itemType !== 'milk' && items?.itemType !== 'curd') {
        const itemTotal = parseFloat(items?.itemPrice) * ( parseFloat(items?.itemGrade) * parseFloat(items?.qty));
        sales += itemTotal;
      }
    });

    return sales;
  };

  let invTotal = 0;
  let invCount = 0;
  let milkTotal = 0;
  let curdTotal = 0;
  let otherTotal = 0;
  return (
    <>
      <Header />
      <Sidebar />
      <div className="content-wrapper">
        <div className="container-full">
          <section className="content">
            <div className="box">
               <div className="box-header with-border">
                <div className="row mt-3">
                  <div className="col-md-3"><h4 className="box-title">Master Ledger</h4></div>
                  <div className="col-md-3"></div>
                  <div className="col-md-3">
                    <input
                      type="date"
                      className="form-control"
                      value={startDate}
                      onChange={(e) => setStartDate(e.target.value)}
                    />
                  </div>
                  <div className="col-md-3">
                    <input
                      type="date"
                      className="form-control"
                      value={endDate}
                      onChange={(e) => setEndDate(e.target.value)}
                    />
                  </div>               
                </div>
              </div>

              <div className="box-body">
                <div className="row">
                  {ledgers?.map((ledger, index) =>{

                    const recieptAmount = getLedgerTotal(ledger?.id, reciepts);
                    const cdNoteAmount = getLedgerTotal(ledger?.id, cdNote);
                    const bankAmount = getLedgerTotal(ledger?.id, bankCollection);
                    const invAmount = ledger?.id === '1' ? invoiceTotal : 0;

                    const totalAmount = recieptAmount + cdNoteAmount + bankAmount + invAmount;
                    return (
                      <div className="col-md-12 col-lg-3 col-xl-3" onClick={()=>setSelLedg(ledger?.id)}>
                        <div className="card border-radius-10">
                          <div className={` ${selLedg === ledger?.id ? 'bg-success border-radius-10' : ''}`}>
                            <p className="m-2 p-2 text-bold border-bottom">{ledger?.masterName}</p>
                          </div>
                          <div className={`card-body ${selLedg === ledger?.id ? 'bg-secondary card border-radius-10' : ''}`}>
                            <table width="100%">
                              {invAmount > 0 && 
                                <tr>
                                  <td className="text-left">Invoice</td>
                                  <td className="text-center">:</td>
                                  <td className="text-end">{Number(invAmount).toFixed(2) }</td>
                                </tr>
                              }

                              {recieptAmount > 0 && 
                                <tr>
                                  <td className="text-left">Receipts</td>
                                  <td className="text-center">:</td>
                                  <td className="text-end">{Number(recieptAmount).toFixed(2) }</td>
                                </tr>
                              }

                              {cdNoteAmount > 0 && 
                                <tr>
                                  <td className="text-left">C/D Note</td>
                                  <td className="text-center">:</td>
                                  <td className="text-end">{Number(cdNoteAmount).toFixed(2) }</td>
                                </tr>
                              }

                              {bankAmount > 0 && 
                                <tr>
                                  <td className="text-left">Bank Collection</td>
                                  <td className="text-center">:</td>
                                  <td className="text-end">{Number(bankAmount).toFixed(2) }</td>
                                </tr>
                              }

                              {totalAmount > 0 && 
                                 <tr>
                                  <th className="text-left">Total</th>
                                  <td className="text-center">:</td>
                                  <th className="text-end">{Number(totalAmount).toFixed(2) }</th>
                                </tr>
                              }
                            </table>
                          </div>
                        </div>
                      </div>
                    )}
                  )}

                  <div className="col-12">
                    <div className="card border-radius-10 p-2">
                      {selLedg === '1' ?
                        <div className="table-responsive" style={{width: '100%', height: 'calc(100vh - 160px)', overflow: 'auto', padding: '0 10px 10px 10px'}}>
                          <table className="table-sm fs-12 text-fade table-bordered table-hover display nowrap margin-top-10 w-p100">
                            <thead>
                              <tr className="text-dark text-center" style={{ position: 'sticky', top: -1, zIndex: 2, backgroundColor: '#f8f9fa' }}>
                                <th width="10%">Date</th>
                                <th width="20%">Invoices</th>
                                <th>Curd Sales</th>
                                <th>Milk Sales</th>
                                <th>Other Sales</th>
                                <th colSpan={3} className="text-end">Invoice Amount</th>
                              </tr>
                            </thead>
                            <tbody>
                              {Object.values(groupedInvoices).map((group, index) => {
                                invTotal += group.totalAmount;
                                invCount += group.count;
                                milkTotal += group.milkSales;
                                curdTotal += group.curdSales;
                                otherTotal += group.otherSales;
                                const isExpanded = expandedDate === group.date;

                                return (
                                  <React.Fragment key={group.date}>
                                    {/* Group row */}
                                    <tr
                                      style={{ cursor: "pointer" }}
                                      onClick={() => toggleDate(group.date)}
                                      className={isExpanded ? 'bg-warning text-dark' : ''}
                                    >
                                      <td className="text-center">
                                        {group.date} <b>{isExpanded ? "↴" : "⇢"}</b> 
                                      </td>
                                      <td className="text-center">{group.count}</td>
                                      <td className="text-end">{Number(group.curdSales).toFixed(2)}</td>
                                      <td className="text-end">{Number(group.milkSales).toFixed(2)}</td>
                                      <td className="text-end">{Number(group.otherSales).toFixed(2)}</td>
                                      <td colSpan={3} className={isExpanded ? 'text-end text-bold' : 'text-end'}>
                                        {Number(group.totalAmount).toFixed(2)}
                                      </td>
                                    </tr>

                                    {/* Expanded invoice rows */}
                                    {isExpanded &&
                                    <>
                                    <tr>
                                      <th className="text-center">S.NO</th>
                                      <th colSpan={2}>Party</th>
                                      <th className="text-center">Invoice Id</th>
                                      <th className="text-center">Curd Sales</th>
                                      <th className="text-center">Milk Sales</th>
                                      <th className="text-center">Other Sales</th>
                                      <th className="text-center">Total Amount</th>
                                    </tr>
                                    
                                      {group.invoices.map((inv, i) => (
                                        <tr key={`${group.date}-${i}`} className="bg-light">
                                          <td className="text-center">{i+1}</td>
                                          <td colSpan={2} className="ps-4">
                                            {inv.partyName}
                                          </td>
                                          <td>
                                            TRC/{inv?.invoiceId}/{getFiscalYearLabel(new Date(inv?.date))}
                                          </td>
                                          <td className="text-end">{Number(getSalesValue('curd', inv?.orderData)).toFixed(2)}</td>
                                          <td className="text-end">{Number(getSalesValue('milk', inv?.orderData)).toFixed(2)}</td>
                                          <td className="text-end">{Number(getSalesValueOthers(inv?.orderData)).toFixed(2)}</td>
                                          <td className="text-end">
                                            {Number(inv.amount).toFixed(2)}
                                          </td>
                                        </tr>
                                      ))}
                                      </>}
                                  </React.Fragment>
                                );
                              })}

                              {/* Grand total */}
                              <tr>
                                <th>Total</th>
                                <th className="text-center">{invCount}</th>
                                <th className="text-end">{Number(curdTotal).toFixed(2)}</th>
                                <th className="text-end">{Number(milkTotal).toFixed(2)}</th>
                                <th className="text-end">{Number(otherTotal).toFixed(2)}</th>
                                <th className="text-end">{Number(invTotal).toFixed(2)}</th>
                              </tr>
                            </tbody>

                          </table>
                        </div>
                      : selLedg === '2' ?
                        <div>
                        </div>
                      : selLedg === '3' ?
                        <div>
                        </div>
                      
                      : selLedg === '4' ?
                        <div>
                        </div>
                      : 
                        <div className="flex text-center" style={{minHeight: '200px', justifyContent: 'center', alignItems: 'center'}}>
                          <p className="text-danger">Select Legder to view more details</p>
                        </div>
                      }
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </>
  );
};

export default MasterLedgerReport;